import React from "react";
import { Container, SectionLabel, ButtonLux } from "@/components/primitives";

const HANDLE = "onedot6";
const URL = "https://instagram.com/onedot6";
const EMBED_URL = `https://www.instagram.com/${HANDLE}/embed/`;

/** Instagram section — editorial copy + official profile embed. */
export default function InstagramSection() {
  return (
    <Container className="mt-24 md:mt-40" >
      <div className="flex flex-col md:flex-row gap-8 md:gap-20" data-testid="ig-section">
        <div className="flex-1 md:pt-6">
          <SectionLabel>· The Studio ·</SectionLabel>
          <h2 className="font-serif font-light text-lux-ink tracking-tight leading-[1.05] mt-4 text-4xl md:text-5xl lg:text-6xl">
            Follow the studio<br />on Instagram.
          </h2>
          <p className="text-base text-lux-sec font-light leading-relaxed mt-5 max-w-md">
            Moments from finished projects, atelier visits and material studies. Quiet posts, on cue.
          </p>
          <div className="mt-7 flex items-center gap-4 flex-wrap">
            <ButtonLux label={`@${HANDLE}`} variant="outline" href={URL} testId="ig-follow-btn" />
            <span className="text-xs text-lux-muted tracking-wider">Open in Instagram</span>
          </div>
        </div>
        <div className="flex-1 flex items-center justify-center">
          <div className="w-full max-w-[540px] border border-lux-line bg-lux-surface p-2">
            <iframe
              src={EMBED_URL}
              title={`Instagram · @${HANDLE}`}
              className="w-full block"
              style={{ border: "none", background: "transparent", height: 620 }}
              loading="lazy"
              scrolling="no"
            />
          </div>
        </div>
      </div>
    </Container>
  );
}
